import PropTypes from "prop-types"
import React from "react"

import { Tag as BaseTag, Text } from "./styled"

/**
 * Component that displays a tag with text and an optional icon
 *
 * @param {object} props
 * @param {string} props.text - Text to display in the tag
 * @param {string} props.variant - The variant of the tag
 * @param {React.ReactNode} props.children - Optional icon to display in the tag
 * @returns {JSX.Element}
 */
export const Tag = ({ text, variant = "standard", children, ...props }) => {
  return (
    <BaseTag $variant={variant} {...props}>
      {text && <Text xs text={text} $variant={variant} />}
      {children}
    </BaseTag>
  )
}

Tag.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.node,
}
